export default "__VITE_ASSET__BaQtjZI2__"